import { render, staticRenderFns } from "./ExpenseAllocationPdf.vue?vue&type=template&id=d0d09006&"
import script from "./ExpenseAllocationPdf.vue?vue&type=script&lang=js&"
export * from "./ExpenseAllocationPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports